import ShindeHouse from "./ShindeHouse";
import StellarHomes from "./StellarHomes";
import BunglowInterior from "./BunglowInterior";
import RiverstoneResidence from "./RiverstoneResidence";
import UpComingProject from "./UpComingProject";
import UpcomingResidentialProject from "./UpcomingResidentialProject";

// Future projects .
// import LimestoneResidence from "./LimestoneResidence";
// import WhiteCourtHouse from "./WhiteCourtHouse";
// import MonochromeResidence from "./MonochromeResidence";
// import ConcreteAndWood from "./ConcreteAndWood";
// import GraphiteKitchen from "./GraphiteKitchen";
// import WarmStoneHome from "./WarmStoneHome";
// import AtelierMinimal from "./AtelierMinimal";
// import QuietGeometry from "./QuietGeometry";
// import EarthResidence from "./EarthResidence";
// import FrameHouse from "./FrameHouse";

export const PROJECT_ORDER = [
  "shinde-house",
  "stellar-homes",
  "bunglow-interior",
  "riverstone-residence",
  // "graphite-kitchen",
  "up-coming-project",
  "upcoming-residential-project",

  // Future projects - uncomment when needed.
  // "limestone-residence",
  // "white-court-house",
  // "monochrome-residence",
  // "concrete-and-wood",
  // "warm-stone-home",
  // "atelier-minimal",
  // "quiet-geometry",
  // "earth-residence",
  // "frame-house",
];

export const PROJECT_DETAILS = {
  "shinde-house": ShindeHouse,
  "stellar-homes": StellarHomes,
  "bunglow-interior": BunglowInterior,
  "riverstone-residence": RiverstoneResidence,
  "up-coming-project": UpComingProject,
  "upcoming-residential-project": UpcomingResidentialProject,

  // Future projects - uncomment when needed.
  // "limestone-residence": LimestoneResidence,
  // "white-court-house": WhiteCourtHouse,
  // "monochrome-residence": MonochromeResidence,
  // "concrete-and-wood": ConcreteAndWood,
  // "graphite-kitchen": GraphiteKitchen,
  // "warm-stone-home": WarmStoneHome,
  // "atelier-minimal": AtelierMinimal,
  // "quiet-geometry": QuietGeometry,
  // "earth-residence": EarthResidence,
  // "frame-house": FrameHouse,
};
